import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"text-align":"left"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 3 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { key: 4 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Load a JSON file of API output here: ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "or copy records in as text in the box below.", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode()
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Use the tab buttons at the top of the page to interact with your data in different ways. ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode()
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { key: 5 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, " This page allows you to filter different kinds of records out of the data set which may be irrelevant to your audit ", -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Show these types:")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" verified ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" unverified ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" error ")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Show records with the following recommendations:")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" display ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" search ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" none ")
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Keep only records likely to have transliterated titles?")
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" yes ")
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "flexcontainer" }
const _hoisted_50 = { class: "scrollbox" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = { dir: "rtl" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode()
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createTextVNode()
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = { class: "scrollbox" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = { dir: "rtl" }
const _hoisted_62 = /*#__PURE__*/_createTextVNode()
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode()
const _hoisted_65 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_66 = ["href"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("button", null, "export remaining", -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = ["href"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("button", null, "export removed", -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = { key: 6 }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = /*#__PURE__*/_createTextVNode()
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = {
  class: "worktitle",
  style: {"display":"inline-block"}
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = {
  class: "hebrew",
  dir: "rtl",
  style: {"text-align-last":"right"}
}
const _hoisted_80 = /*#__PURE__*/_createTextVNode()
const _hoisted_81 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_84 = { key: 0 }
const _hoisted_85 = ["href"]
const _hoisted_86 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_87 = ["href"]
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_89 = ["href"]
const _hoisted_90 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_91 = ["href"]
const _hoisted_92 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_93 = { key: 1 }
const _hoisted_94 = { key: 2 }
const _hoisted_95 = { style: {"display":"inline-block","margin-left":"1em","font-size":"0.9em"} }
const _hoisted_96 = ["href"]
const _hoisted_97 = {
  class: "hebrew",
  dir: "rtl",
  style: {"text-align-last":"right","margin-left":"1em"}
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_101 = {
  key: 4,
  dir: "rtl"
}
const _hoisted_102 = { key: 1 }
const _hoisted_103 = { key: 2 }
const _hoisted_104 = { key: 0 }
const _hoisted_105 = ["onClick"]
const _hoisted_106 = { dir: "ltr" }
const _hoisted_107 = {
  class: "hebrew",
  style: {"font-size":"1.6em"}
}
const _hoisted_108 = { class: "dropdown-content" }
const _hoisted_109 = ["onClick"]
const _hoisted_110 = { key: 1 }
const _hoisted_111 = ["onClick"]
const _hoisted_112 = ["id", "onUpdate:modelValue", "onKeyUp"]
const _hoisted_113 = ["href"]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_115 = ["onClick"]
const _hoisted_116 = /*#__PURE__*/_createTextVNode()
const _hoisted_117 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_118 = ["onClick"]
const _hoisted_119 = /*#__PURE__*/_createTextVNode()
const _hoisted_120 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_121 = ["onClick"]
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" move ")
const _hoisted_123 = ["onClick"]
const _hoisted_124 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_125 = { key: 5 }
const _hoisted_126 = { key: 0 }
const _hoisted_127 = { key: 1 }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createTextVNode("full API output:"),
  /*#__PURE__*/_createElementVNode("td")
], -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_131 = { key: 7 }
const _hoisted_132 = { class: "scrollbox" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_134 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_136 = {
  key: 0,
  dir: "rtl"
}
const _hoisted_137 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_139 = /*#__PURE__*/_createTextVNode()
const _hoisted_140 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_141 = ["href"]
const _hoisted_142 = /*#__PURE__*/_createElementVNode("button", null, "export audited", -1)
const _hoisted_143 = [
  _hoisted_142
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((typeof _ctx.recordsObject !== 'string' || _ctx.audited.length !== 0))
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currTab = _ctx.Tab.Input)),
            class: _normalizeClass(_ctx.isActive(_ctx.Tab.Input))
          }, " input records (" + _toDisplayString((typeof _ctx.recordsObject) !== 'string' ? _ctx.recordsObject.length : 0) + ") ", 3)
        ]))
      : _createCommentVNode("", true),
    ((typeof _ctx.recordsObject !== 'string'))
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currTab = _ctx.Tab.Filter)),
            class: _normalizeClass(_ctx.isActive(_ctx.Tab.Filter))
          }, " filter input ", 2),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currTab = _ctx.Tab.Audit)),
            class: _normalizeClass(_ctx.isActive(_ctx.Tab.Audit))
          }, " audit individual records ", 2)
        ]))
      : _createCommentVNode("", true),
    ((typeof _ctx.recordsObject !== 'string' || _ctx.audited.length !== 0))
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currTab = _ctx.Tab.Export)),
            class: _normalizeClass(_ctx.isActive(_ctx.Tab.Export))
          }, " export audited (" + _toDisplayString(_ctx.audited.length) + ") ", 3)
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    _hoisted_6,
    (typeof _ctx.currentRecord === 'string')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.currentRecord) + " ", 1),
          _hoisted_8,
          _hoisted_9
        ]))
      : _createCommentVNode("", true),
    (_ctx.currTab === 'input')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _createElementVNode("input", {
            type: "file",
            id: "recordInput",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadFile($event)))
          }, null, 32),
          _hoisted_13,
          _hoisted_14,
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.textRecords) = $event))
          }, null, 512), [
            [_vModelText, _ctx.textRecords]
          ]),
          _hoisted_15,
          _hoisted_16,
          (typeof _ctx.currentRecord === 'string')
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Once records are loaded tabs will appear above to provide further functionality. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearInput && _ctx.clearInput(...args)))
                }, "clear input (cannot be undone)"),
                _hoisted_19,
                _hoisted_20,
                _hoisted_21,
                _hoisted_22,
                _hoisted_23,
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _createTextVNode(" current number of input records: " + _toDisplayString(_ctx.recordsObject.length), 1)
              ]))
        ]))
      : _createCommentVNode("", true),
    (_ctx.currTab === 'filter')
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _hoisted_28,
          _hoisted_29,
          _hoisted_30,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "verified",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filVerified) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.filVerified]
          ]),
          _hoisted_31,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "unverified",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filUnverified) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.filUnverified]
          ]),
          _hoisted_32,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "error",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filError) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.filError]
          ]),
          _hoisted_33,
          _hoisted_34,
          _hoisted_35,
          _hoisted_36,
          _hoisted_37,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "display",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filDisplay) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.filDisplay]
          ]),
          _hoisted_38,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "search",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filSearch) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.filSearch]
          ]),
          _hoisted_39,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "none",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filNoRecommendation) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.filNoRecommendation]
          ]),
          _hoisted_40,
          _hoisted_41,
          _hoisted_42,
          _hoisted_43,
          _hoisted_44,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "likelyTranscription",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filLikelyTranscription) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.filLikelyTranscription]
          ]),
          _hoisted_45,
          _hoisted_46,
          _hoisted_47,
          (_ctx.filterResults !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createTextVNode(" remaining records: " + _toDisplayString(_ctx.filterResults[0].length) + " ", 1),
                    _hoisted_51,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterResults[0], (el, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, [
                        _createTextVNode(_toDisplayString(_ctx.getTitle(el)), 1),
                        _hoisted_52,
                        _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.getHebrewTitle(el)), 1),
                        _hoisted_54,
                        _hoisted_55,
                        _hoisted_56,
                        _hoisted_57
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createTextVNode(" removed records: " + _toDisplayString(_ctx.filterResults[1].length) + " ", 1),
                    _hoisted_59,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterResults[1], (el, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, [
                        _createTextVNode(_toDisplayString(_ctx.getTitle(el)), 1),
                        _hoisted_60,
                        _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.getHebrewTitle(el)), 1),
                        _hoisted_62,
                        _hoisted_63,
                        _hoisted_64,
                        _hoisted_65
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
                }, "apply filters"),
                _createElementVNode("a", {
                  href: _ctx.exportRemaining(),
                  download: "remaining.json"
                }, _hoisted_68, 8, _hoisted_66),
                _createElementVNode("a", {
                  href: _ctx.exportRemoved(),
                  download: "removed.json"
                }, _hoisted_71, 8, _hoisted_69)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.currTab === 'audit')
      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
          ((typeof _ctx.currentRecord!== 'string'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                _createElementVNode("em", null, _toDisplayString(_ctx.currentRecord.type), 1),
                _hoisted_74,
                _hoisted_75,
                _createElementVNode("div", _hoisted_76, [
                  _createTextVNode(_toDisplayString(_ctx.getTitle(_ctx.currentRecord)) + " ", 1),
                  _hoisted_77,
                  _hoisted_78,
                  _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.currentHebrewTitle), 1)
                ]),
                _hoisted_80,
                _hoisted_81,
                _createTextVNode(" " + _toDisplayString(_ctx.getDate(_ctx.currentRecord)) + " ", 1),
                _hoisted_82,
                _createTextVNode(" " + _toDisplayString(_ctx.getPublisher(_ctx.currentRecord)) + " ", 1),
                _hoisted_83,
                _createTextVNode(" " + _toDisplayString(_ctx.getCreator(_ctx.currentRecord)), 1),
                (_ctx.currentRecord.type !== 'error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                      _createElementVNode("a", {
                        href: _ctx.applyQuery('nli', _ctx.currentConverted.converted),
                        target: "_blank"
                      }, "search NLI", 8, _hoisted_85),
                      _hoisted_86,
                      _createElementVNode("a", {
                        href: _ctx.applyQuery('kvk', _ctx.currentConverted.converted),
                        target: "_blank"
                      }, "search KVK", 8, _hoisted_87),
                      _hoisted_88,
                      _createElementVNode("a", {
                        href: _ctx.applyQuery('google', _ctx.currentConverted.converted),
                        target: "_blank"
                      }, " search Google ", 8, _hoisted_89),
                      _hoisted_90,
                      _createElementVNode("a", {
                        href: _ctx.applyQuery('googleTranslate', _ctx.currentConverted.converted),
                        target: "_blank"
                      }, " Google Translate ", 8, _hoisted_91)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_92,
                (_ctx.currentRecord.type === 'verified')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_93, "matched title:"))
                  : _createCommentVNode("", true),
                (_ctx.currentRecord.type === 'unverified')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, "top query result: "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("a", {
                    href: _ctx.topQuery.link,
                    target: "_blank"
                  }, [
                    _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.delist(_ctx.topQuery.text)), 1)
                  ], 8, _hoisted_96),
                  (_ctx.currentRecord.type === 'unverified')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.acceptTopQuery && _ctx.acceptTopQuery(...args))),
                        style: {"font-size":"0.8em"}
                      }, " accept top query result "))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_98,
                _hoisted_99,
                (_ctx.currentRecord.type !== 'error')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)))
                    }, " accept displayed title "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.reject && _ctx.reject(...args)))
                }, "reject"),
                _createElementVNode("button", {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showCorrectionInterface = !(_ctx.showCorrectionInterface))),
                  class: _normalizeClass(_ctx.showCorrectionInterface ? 'active' : '')
                }, " edit title ", 2),
                _createElementVNode("button", {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showFullRecord = !(_ctx.showFullRecord))),
                  class: _normalizeClass((_ctx.showFullRecord ? 'active': ''))
                }, " show full record ", 2),
                _createElementVNode("button", {
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.undo && _ctx.undo(...args)))
                }, " undo last "),
                _hoisted_100,
                (_ctx.showCorrectionInterface)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                      (_ctx.showSimpleEditor)
                        ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                            key: 0,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.simpleEditorText) = $event)),
                            style: {"font-size":"1.3em","font-family":"'Times New Roman', Times, serif"},
                            rows: "3"
                          }, null, 512)), [
                            [_vModelText, _ctx.simpleEditorText]
                          ])
                        : (_ctx.repContainers === null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_102, "loading editor..."))
                          : (_openBlock(), _createElementBlock("div", _hoisted_103, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repContainers, (word, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "word-box hover-me",
                                  key: index
                                }, [
                                  (!word.hot)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                        _createElementVNode("div", {
                                          onClick: ($event: any) => (_ctx.activateEditor(word))
                                        }, [
                                          _createElementVNode("div", _hoisted_106, " " + _toDisplayString(word.currKey), 1),
                                          _createElementVNode("div", _hoisted_107, _toDisplayString(word.currRep) + " ", 1)
                                        ], 8, _hoisted_105),
                                        _createElementVNode("div", _hoisted_108, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(word.reps, (rep) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "hebrew",
                                              onClick: ($event: any) => (word.currRep = rep),
                                              style: {"font-size":"1.6em"},
                                              key: rep
                                            }, _toDisplayString(rep), 9, _hoisted_109))
                                          }), 128))
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                        _createElementVNode("div", {
                                          dir: "ltr",
                                          onClick: ($event: any) => (word.hot = false)
                                        }, " " + _toDisplayString(word.currKey), 9, _hoisted_111),
                                        _withDirectives(_createElementVNode("input", {
                                          id: 'input' + word.idx,
                                          class: "hebrew",
                                          "onUpdate:modelValue": ($event: any) => ((word.currRep) = $event),
                                          style: _normalizeStyle(_ctx.boxSize(word, 1) + "; font-size:1.6em"),
                                          onKeyUp: _withKeys(($event: any) => (word.hot = false), ["enter"])
                                        }, null, 44, _hoisted_112), [
                                          [_vModelText, word.currRep]
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("a", {
                                            href: _ctx.applyQuery('morfix', word.currRep),
                                            target: "_blank"
                                          }, "morfix", 8, _hoisted_113),
                                          _hoisted_114,
                                          _createElementVNode("button", {
                                            onClick: ($event: any) => (_ctx.deleteWord(word))
                                          }, "delete word", 8, _hoisted_115),
                                          _hoisted_116,
                                          _hoisted_117,
                                          _createElementVNode("button", {
                                            onClick: ($event: any) => (_ctx.addWord(word))
                                          }, "add word", 8, _hoisted_118),
                                          _hoisted_119,
                                          _hoisted_120,
                                          _createElementVNode("button", {
                                            onClick: ($event: any) => (_ctx.moveWord(word, -1))
                                          }, "<-", 8, _hoisted_121),
                                          _hoisted_122,
                                          _createElementVNode("button", {
                                            onClick: ($event: any) => (_ctx.moveWord(word, 1))
                                          }, "->", 8, _hoisted_123)
                                        ])
                                      ]))
                                ]))
                              }), 128))
                            ])),
                      _hoisted_124,
                      _createElementVNode("button", {
                        onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.acceptEdited && _ctx.acceptEdited(...args)))
                      }, "accept edited Hebrew"),
                      _createElementVNode("button", {
                        onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.toggleSimpleEditor())),
                        class: _normalizeClass(_ctx.showSimpleEditor? 'active' : '')
                      }, "use simple editor", 2)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showFullRecord && (typeof _ctx.currentRecord !== 'string'))
                  ? (_openBlock(), _createElementBlock("table", _hoisted_125, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentRecord.record, (value, name, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(name) + ":", 1),
                          (Array.isArray(value) && value.length === 1)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_126, _toDisplayString(value[0]), 1))
                            : (_openBlock(), _createElementBlock("td", _hoisted_127, _toDisplayString(value), 1))
                        ]))
                      }), 128)),
                      _hoisted_128,
                      _hoisted_129,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentRecord, (value, name, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("code", null, _toDisplayString(name) + ":", 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("code", null, _toDisplayString(value), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_130
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.currTab === 'export')
      ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
          _createElementVNode("div", _hoisted_132, [
            _hoisted_133,
            _hoisted_134,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audited, (el, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createTextVNode(_toDisplayString(_ctx.getTitle(el)), 1),
                _hoisted_135,
                (el.audit_result.title)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_136, [
                      _createTextVNode(_toDisplayString(el.audit_result.title) + " ", 1),
                      _hoisted_137
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("em", null, _toDisplayString(el.audit_result.type), 1),
                _hoisted_138,
                _hoisted_139,
                _hoisted_140
              ]))
            }), 128))
          ]),
          _createElementVNode("a", {
            href: _ctx.exportAudited(),
            download: "audited.json"
          }, _hoisted_143, 8, _hoisted_141),
          _createElementVNode("button", {
            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.clearAudited && _ctx.clearAudited(...args)))
          }, "clear audited (cannot be undone)")
        ]))
      : _createCommentVNode("", true)
  ]))
}